import { render, staticRenderFns } from "./generateAuctionPackagesDialog.vue?vue&type=template&id=208abbf6&lang=pug"
import script from "./generateAuctionPackagesDialog.vue?vue&type=script&lang=js"
export * from "./generateAuctionPackagesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports